import styled from "styled-components";
const TabPanelsImpl = styled("div")({
  display: "flex",
  flex: "1 0 auto",
  flexDirection: "column"
});
export {
  TabPanelsImpl
};
